<script lang="ts" setup>
import type { Player, Team } from '~/types'

interface Props {
  team: Team.Model
  player: Player.Model
}

const props = defineProps<Props>()

const playerId = computed<number>(() => props.player.id)

const { errorObject } = useShowApiError('Player Not Found')

const { fetchData: fetchPlayerRosters } = useLoadPlayerRostersById(playerId.value, {
  include: ['roster', 'roster.season', 'roster.team', 'roster.team.logo'],
})

const {
  data: playerRosters,
  error: playerRostersError,
} = await useAsyncData(`player:roster-players:${props.player.id}`, () => fetchPlayerRosters())

if (playerRostersError.value || playerRosters.value === null) {
  throw errorObject
}
const { schemas, hasSchemas } = usePlayerRosterStatistics(playerRosters)
</script>

<template>
  <div class="player-stats-page">
    <Wrapper>
      <div
        v-if="!hasSchemas"
        class="player-stats-page__empty"
      >
        No statistics found.
      </div>
      <template v-else>
        <PlayerStatsCategory
          v-for="(schema, index) in schemas"
          :key="index"
          v-bind="schema"
        />
      </template>
    </Wrapper>
  </div>
</template>

<style lang="scss" scoped>
.player-stats-page {
  @apply overflow-auto mb-[20px];
  @apply md:mb-[40px];

  &__empty {
    @apply text-center text-2xl;
  }
}
</style>
